import React, { useEffect } from 'react';
import PartnerMain from '../../components/partner/PartnerMain';
import PartnerSellingPoint from '../../components/partner/PartnerSellingPoint';
import PartnerPoint1 from '../../components/partner/PartnerPoint1';
import PartnerPoint2 from '../../components/partner/PartnerPoint2';
import PartnerPoint3 from '../../components/partner/PartnerPoint3';
import PartnerOpenGuide from '../../components/partner/PartnerOpenGuide';
import PartnerStart from '../../components/partner/PartnerStart';
import PartnerFAQ from '../../components/partner/PartnerFAQ';

const PartnerPage = () => {
  useEffect(() => {
    document.title = '폰피쉬 파트너 | 안경원 입점 안내';
  }, []);

  return (
    <div className="w-full pt-[60px] md:pt-[80px] md:pt-0">
      <PartnerMain />
      <PartnerSellingPoint />
      <PartnerPoint1 />
      <PartnerPoint2 />
      <PartnerPoint3 />
      <PartnerOpenGuide />
      <PartnerStart />
      {/* <PartnerFAQ /> */}
    </div>
  );
};

export default PartnerPage; 